import { useEffect } from 'react';

/**
 * Warns the user before navigating away when there are unsaved form changes.
 * Uses the browser's beforeunload event for tab close/refresh.
 *
 * Usage with React Hook Form:
 *   const { formState: { isDirty } } = useForm();
 *   useUnsavedChanges(isDirty);
 *
 * Usage with manual tracking:
 *   const [isDirty, setIsDirty] = useState(false);
 *   useUnsavedChanges(isDirty);
 */
export function useUnsavedChanges(isDirty: boolean) {
    useEffect(() => {
        if (!isDirty) return;

        const handler = (e: BeforeUnloadEvent) => {
            e.preventDefault();
            // Chrome requires returnValue to be set
            e.returnValue = '';
        };

        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, [isDirty]);
}
